export async function hasWebPBasicSupport() {
    return await test(
        'data:image/webp;base64,UklGRjIAAABXRUJQVlA4ICYAAACyAgCdASoCAAEALmk0mk0iIiIiIgBoSygABc6zbAAA/v56QAAAAA==',
    );
}

export async function hasWebPLossLessSupport() {
    return await test('data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=');
}

async function test(src) {
    if (window.Modernizr && Modernizr.webp) {
        return await true;
    }

    return await new Promise((resolve) => {
        const image = new Image();

        image.onload = async () => resolver();
        image.onerror = async () => resolver();

        image.src = src;

        function resolver() {
            return resolve(image.height && image.width);
        }
    });
}



// WEBPACK FOOTER //
// ./js/main/package/has-webp-support.js